import { GetAuthTokenCache, YammerCache, getTokenCacheTimeToLive } from '../cache';
import { Authenticator, AuthenticatorType } from '../types';

import { getAuthToken } from './getAuthToken';

export default class TeamsAuthenticator implements Authenticator {
  public readonly type: AuthenticatorType = AuthenticatorType.Teams;
  protected readonly authTokenCache: YammerCache | undefined;

  constructor(getAuthTokenCache: GetAuthTokenCache) {
    this.authTokenCache = getAuthTokenCache();
  }

  public acquireToken = async (
    [resource]: string[],
    claims?: string,
    tenantId?: string,
    silent?: boolean
  ): Promise<string> => {
    if (!claims && !tenantId) {
      const cachedToken = this.getTokenFromCache(resource);
      if (cachedToken) {
        return cachedToken;
      }
    }

    const token = await this.getToken(resource, claims ? [claims] : undefined, tenantId, silent);

    if (!claims && !tenantId) {
      this.addTokenToCache(resource, token);
    }

    return token;
  };

  public getToken = (resource: string, claims?: string[], tenantId?: string, silent?: boolean): Promise<string> =>
    getAuthToken({ resource, claims, tenantId, silent });

  public addTokenToCache = (resource: string, token: string): void => {
    const ttl = getTokenCacheTimeToLive(token);
    if (ttl && this.authTokenCache) {
      this.authTokenCache.setItem(resource, token, ttl);
    }
  };

  public getTokenFromCache = (resource: string): string | null => {
    if (this.authTokenCache) {
      return this.authTokenCache.getItem<string>(resource);
    }

    return null;
  };

  public acquireTokenRedirect() {
    throw new Error('acquireTokenRedirect is not implemented');
  }

  public setThirdPartyCookieErrorCallback() {
    throw new Error('setThirdPartyCookieErrorCallback is not implemented');
  }
}
